import React from "react";
import logo from "../images/Rick_and_Morty_-_logo.png";

const Footer = () => {
  return (
    <>
      <img src={logo} alt="Logo" title="Logo"></img>
      <p>Buscador intergaláctico by AzaharaGarcía & Adalab</p>
      <p>2021</p>
    </>
  );
};

export default Footer;
